// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2C9sU","headerIcon":"header_headerIcon__1_t1e","headerText":"header_headerText__2ywPo"};